<ng-container *ngIf="projetprofessionnel$ | async as projetprofessionnel">
  <i nz-icon nzType="loading" class="loading" *ngIf="loading$ | async"></i>

  <app-layout-list
    *ngIf="formations$ | async | size; else noResults"
    [card]="card"
    [new]="new"
    [source]="formations$ | async"
  ></app-layout-list>

  <ng-template #new>
    <app-card-new
      [type]="'school'"
      [title]="newCardTitle"
      [description]="newCardDescription"
      [definition]="newCardDefinition"
      [width]="'300px'"
      [height]="'280px'"
      (add)="onNew(participant, projetprofessionnel)"
      (back)="onBack()"
      (cancel)="onBack()"
    ></app-card-new>
  </ng-template>

  <ng-template #card let-item let-position="idx">
    <nz-card
      nzHoverable
      nzSize="small"
      [nzTitle]="formationSuggestionTitle"
      class="formationSuggestion_card"
      (click)="onSelect(item)"
      [nzExtra]="cardFormationProjetproExtra"
    >
      <ng-template #formationSuggestionTitle>
        <app-header-title
          [icon]="'school'"
          [subtitle]="true"
          [title]="''"
          [height]="'35px'"
          [width]="'35px'"
        ></app-header-title>
      </ng-template>
      <div class="formation_title">
        {{ item?.ci_intitule_type_diplome | carLimitation: 45 }}
      </div>

      <div class="formation_subtitle">
        <strong>{{ item?.rncp_intitule | carLimitation: 60 }}</strong>
      </div>
      <nz-divider nzOrientation="center" nzType="horizontal"></nz-divider>

      <nz-row nzAlign="middle" nzGutter="8" nzJustify="start">
        <nz-col nzSpan="24">
          <nz-tag nzColor="geekblue">{{
            item?.ideo_identifiant_formation
          }}</nz-tag>
        </nz-col>
      </nz-row>
      <nz-row nzAlign="middle" nzGutter="8" nzJustify="start">
        <nz-col nzSpan="24">
          <nz-tag nzColor="geekblue">RNCP{{ item?.ci_code_rncp }}</nz-tag>
        </nz-col>
      </nz-row>
    </nz-card>
    <nz-dropdown-menu #cardExtraFormationProjetprojetpro="nzDropdownMenu">
      <ul nz-menu>
        <li
          nz-menu-item
          nzDanger
          nz-popconfirm
          nzPopconfirmTitle="Voulez-vous retirer cette formation ?"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="onDelete(item, participant, projetprofessionnel)"
          (nzOnCancel)="onCancel()"
        >
          <nz-row nzAlign="middle" nzGutter="8" nzJustify="start">
            <nz-col nzSpan="6">
              <i nz-icon nzType="delete"></i>
            </nz-col>
            <nz-col nzSpan="18"> Supprimer </nz-col>
          </nz-row>
        </li>
      </ul>
    </nz-dropdown-menu>
    <ng-template #cardFormationProjetproExtra>
      <button
        nz-button
        nzShape="circle"
        nz-dropdown
        [nzDropdownMenu]="cardExtraFormationProjetprojetpro"
        nzTrigger="click"
        nzPlacement="bottomRight"
        nzType="text"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    </ng-template>
  </ng-template>

  <ng-template #noResults>
    <app-no-result
      [icon]="'school'"
      [addtitle]="'Ajouter une formation'"
      [notitle]="'Aucun formation ajoutée'"
      (new)="onNew(participant, projetprofessionnel)"
    ></app-no-result>
  </ng-template>

  <ng-template #projetProfessionnelFormationForm>
    <app-header-title [icon]="'school'" [title]="title"></app-header-title>
  </ng-template>
</ng-container>
